<template>
    <div
        class="contact-popup__panel"
        role="dialog"
        aria-modal="true"
        aria-labelledby="contact-popup-title"
    >
        <button
            type="button"
            class="contact-popup__close"
            aria-label="Sluiten"
            @click="$emit('close')"
        >
            <CloseIcon />
        </button>

        <Transition name="contact-popup-step" mode="out-in">
            <SuccessMessage
                v-if="success"
                key="success"
                @close="$emit('close')"
            />

            <div v-else key="form" class="contact-popup__step">
                <div class="contact-popup__header">
                    <h2 id="contact-popup-title" class="contact-popup__title">
                        Kunnen we je ergens mee helpen?
                    </h2>
                </div>

                <p class="contact-popup__intro">
                    Heb je een vraag of wil je persoonlijk advies? Vul het
                    formulier in en wij nemen zo snel mogelijk contact met je op.
                </p>

                <p v-if="generalError" class="contact-popup__general-error">
                    {{ generalError }}
                </p>

                <div v-if="loading" class="contact-popup__loading">
                    Formulier laden...
                </div>

                <ContactForm
                    v-else
                    :fields="fields"
                    :errors="errors"
                    :submitting="submitting"
                    @submit="$emit('submit', $event)"
                />
            </div>
        </Transition>
    </div>
</template>

<script>
import CloseIcon from "./CloseIcon.vue";
import ContactForm from "./ContactForm.vue";
import SuccessMessage from "./SuccessMessage.vue";

export default {
    name: "ContactPopupModal",
    components: {
        CloseIcon,
        ContactForm,
        SuccessMessage,
    },
    props: {
        loading: {
            type: Boolean,
            default: false,
        },
        submitting: {
            type: Boolean,
            default: false,
        },
        fields: {
            type: Array,
            default: () => [],
        },
        errors: {
            type: Object,
            default: () => ({}),
        },
        generalError: {
            type: String,
            default: "",
        },
        success: {
            type: Boolean,
            default: false,
        },
    },
    emits: ["close", "submit"],
    mounted() {
        document.addEventListener("keydown", this.handleKeydown);
    },
    beforeUnmount() {
        document.removeEventListener("keydown", this.handleKeydown);
    },
    methods: {
        handleKeydown(event) {
            if (event.key === "Escape") {
                this.$emit("close");
            }
        },
    },
};
</script>
